import { library } from '@fortawesome/fontawesome-svg-core';
import { faAlignJustify } from '@fortawesome/free-solid-svg-icons/faAlignJustify';
import { faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons/faAngleDoubleLeft';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons/faAngleDoubleRight';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons/faArrowUp';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons/faArrowDown';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faBook } from '@fortawesome/free-solid-svg-icons/faBook';
import { faBullhorn } from '@fortawesome/free-solid-svg-icons/faBullhorn';
import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator';
import { faCalendar } from '@fortawesome/free-solid-svg-icons/faCalendar';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretRight } from '@fortawesome/free-solid-svg-icons/faCaretRight';
import { faCaretSquareDown } from '@fortawesome/free-solid-svg-icons/faCaretSquareDown';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faChartBar } from '@fortawesome/free-solid-svg-icons/faChartBar';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons/faCheckCircle';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faClone } from '@fortawesome/free-solid-svg-icons/faClone';
import { faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons/faCloudUploadAlt';
import { faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons/faCloudDownloadAlt';
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode';
import { faCoffee } from '@fortawesome/free-solid-svg-icons/faCoffee';
import { faCog } from '@fortawesome/free-solid-svg-icons/faCog';
import { faComment } from '@fortawesome/free-solid-svg-icons/faComment';
import { faCubes } from '@fortawesome/free-solid-svg-icons/faCubes';
import { faCircle as faEmptyCircle } from '@fortawesome/free-regular-svg-icons/faCircle';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faExchangeAlt } from '@fortawesome/free-solid-svg-icons/faExchangeAlt';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faFlask } from '@fortawesome/free-solid-svg-icons/faFlask';
import { faFilter } from '@fortawesome/free-solid-svg-icons/faFilter';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faFileImage } from '@fortawesome/free-solid-svg-icons/faFileImage';
import { faFingerprint } from '@fortawesome/free-solid-svg-icons/faFingerprint';
import { faFont } from '@fortawesome/free-solid-svg-icons/faFont';
import { faGavel } from '@fortawesome/free-solid-svg-icons/faGavel';
import { faGlobeAfrica } from '@fortawesome/free-solid-svg-icons/faGlobeAfrica';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage';
import { faKey } from '@fortawesome/free-solid-svg-icons/faKey';
import { faLevelDownAlt } from '@fortawesome/free-solid-svg-icons/faLevelDownAlt';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faUnlink } from '@fortawesome/free-solid-svg-icons/faUnlink';
import { faList } from '@fortawesome/free-solid-svg-icons/faList';
import { faLock } from '@fortawesome/free-solid-svg-icons/faLock';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons/faMapMarker';
import { faMinus } from '@fortawesome/free-solid-svg-icons/faMinus';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons/faPaperclip';
import { faParagraph } from '@fortawesome/free-solid-svg-icons/faParagraph';
import { faPassport } from '@fortawesome/free-solid-svg-icons/faPassport';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons/faPencilAlt';
import { faPlay } from '@fortawesome/free-solid-svg-icons/faPlay';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons/faPowerOff';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons/faQuestionCircle';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons/faQuoteLeft';
import { faQuoteRight } from '@fortawesome/free-solid-svg-icons/faQuoteRight';
import { faSave } from '@fortawesome/free-solid-svg-icons/faSave';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faServer } from '@fortawesome/free-solid-svg-icons/faServer';
import { faSearchMinus } from '@fortawesome/free-solid-svg-icons/faSearchMinus';
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons/faSearchPlus';
import { faSitemap } from '@fortawesome/free-solid-svg-icons/faSitemap';
import { faSort } from '@fortawesome/free-solid-svg-icons/faSort';
import { faSortAlphaDown } from '@fortawesome/free-solid-svg-icons/faSortAlphaDown';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare';
import { faSquare as faSolidSquare } from '@fortawesome/free-solid-svg-icons/faSquare';
import { faStar } from '@fortawesome/free-solid-svg-icons/faStar';
import { faStop } from '@fortawesome/free-solid-svg-icons/faStop';
import { faSync } from '@fortawesome/free-solid-svg-icons/faSync';
import { faTag } from '@fortawesome/free-solid-svg-icons/faTag';
import { faTerminal } from '@fortawesome/free-solid-svg-icons/faTerminal';
import { faTh } from '@fortawesome/free-solid-svg-icons/faTh';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons/faTimesCircle';
import { faToggleOff } from '@fortawesome/free-solid-svg-icons/faToggleOff';
import { faToggleOn } from '@fortawesome/free-solid-svg-icons/faToggleOn';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons/faTrashAlt';
import { faUndo } from '@fortawesome/free-solid-svg-icons/faUndo';
import { faUpload } from '@fortawesome/free-solid-svg-icons/faUpload';
import { faVideo } from '@fortawesome/free-solid-svg-icons/faVideo';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faArrowsAlt } from '@fortawesome/free-solid-svg-icons/faArrowsAlt';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faUsers } from '@fortawesome/free-solid-svg-icons/faUsers';
import { faUserCheck } from '@fortawesome/free-solid-svg-icons/faUserCheck';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons/faUserPlus';
import { faUserTimes } from '@fortawesome/free-solid-svg-icons/faUserTimes';
import { faHandPaper } from '@fortawesome/free-solid-svg-icons/faHandPaper';
import { faBullseye } from '@fortawesome/free-solid-svg-icons/faBullseye';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons/faExternalLinkAlt';
import { twoFactorAuth } from "./two-factor-auth";
import { infoCircleHollow } from "./info-circle-hollow";
import { faTasks } from '@fortawesome/free-solid-svg-icons/faTasks';
import { faMap } from '@fortawesome/free-solid-svg-icons/faMap';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faColumns } from '@fortawesome/free-solid-svg-icons';
import { saveAndNext } from "./save-and-next";
import { exportCsv } from "./export-csv";
import { importCsv } from "./import-csv";
import { copyFrom } from "./copy-from";
import { funnelFilter } from "./funnel-filter";

const icons = {
  faAlignJustify,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowLeft,
  faArrowsAlt,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faBars,
  faBook,
  faBullhorn,
  faCalculator,
  faCalendar,
  faCaretDown,
  faCaretRight,
  faCaretSquareDown,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faClock,
  faClone,
  faCloudUploadAlt,
  faCloudDownloadAlt,
  faCode,
  faCoffee,
  faCog,
  faComment,
  faCubes,
  faEmptyCircle,
  faEnvelope,
  faExchangeAlt,
  faExclamationTriangle,
  faFlask,
  faFile,
  faFilter,
  faFilePdf,
  faFileImage,
  faFingerprint,
  faFont,
  faGavel,
  faGlobeAfrica,
  faHome,
  faImage,
  faInfoCircle,
  faKey,
  faLanguage,
  faLevelDownAlt,
  faLightbulb,
  faLink,
  faUnlink,
  faList,
  faLock,
  faMapMarker,
  faMinus,
  faPaperPlane,
  faPaperclip,
  faParagraph,
  faPassport,
  faPencilAlt,
  faPlay,
  faPlus,
  faPowerOff,
  faQuestionCircle,
  faQuoteLeft,
  faQuoteRight,
  faSave,
  faSearch,
  faServer,
  faSearchMinus,
  faSearchPlus,
  faSitemap,
  faSort,
  faSortAlphaDown,
  faSpinner,
  faSquare,
  faSolidSquare,
  faStar,
  faStop,
  faSync,
  faTag,
  faTerminal,
  faTh,
  faTimes,
  faTimesCircle,
  faToggleOff,
  faToggleOn,
  faTrashAlt,
  faUndo,
  faUpload,
  faVideo,
  faEye,
  faEyeSlash,
  faUser,
  faUsers,
  faUserTimes,
  faUserPlus,
  faUserCheck,
  faHandPaper,
  faExternalLinkAlt,
  faMap,
  faMapMarkerAlt,
  saveAndNext,
  faTasks,
  exportCsv,
  importCsv,
  copyFrom,
  funnelFilter,
  twoFactorAuth,
  infoCircleHollow,
  faBullseye,
  faColumns
};

export const loadIcons = () => {
  library.add(...Object.keys(icons).map((key) => icons[key]));
};

export const iconNames = Object.keys(icons).map((key) => icons[key].iconName);